import PartnerService from 'services/partnerService';
import PartnerConfigsService from 'services/partnerConfigsService';
import LoggerService from 'services/loggerService';
import BookingHelpersService from 'services/bookingHelpersService';
import DateUtilsService from 'services/dateUtilsService';
import EventHelpersService from 'services/eventHelpersService';
import FavoritesService from 'services/favoritesService';
import FormHelpersService from 'services/formHelpersService';
import FraudService from 'services/fraudService';
import IframeService from 'services/iframeService';
import InventorySearchService from 'services/inventorySearchService';
import MembershipService from 'services/membershipService';
import MetaTagService from 'services/metaTagService';
import RegexService from 'services/regexService';
import ResizeService from 'services/resizeService';
import UrlService from 'services/urlService';
import UtilsService from 'services/utilsService';
import ModalService from 'services/modal/modalService';
import TrackingService from 'services/trackingService';
import ConciergeService from 'services/conciergeService';
import modalControllers from './modal';

function init(app) {
  if (!app) throw new Error('app is required');

  modalControllers.init(app);

  app.service('partnerService', PartnerService);
  app.service('partnerConfigs', PartnerConfigsService);
  app.service('loggerService', LoggerService);
  app.service('bookingHelpersService', BookingHelpersService);
  app.service('dateUtilsService', DateUtilsService);
  app.service('eventHelpersService', EventHelpersService);
  app.service('favoritesService', FavoritesService);
  app.service('formHelpersService', FormHelpersService);
  app.service('fraudService', FraudService);
  app.service('iframeService', IframeService);
  app.service('inventorySearchService', InventorySearchService);
  app.service('membershipService', MembershipService);
  app.service('metaTagService', MetaTagService);
  app.service('regexService', RegexService);
  app.service('resizeService', ResizeService);
  app.service('urlService', UrlService);
  app.service('utilsService', UtilsService);
  app.service('modalService', ModalService);
  app.service('trackingService', TrackingService);
  app.service('conciergeService', ConciergeService);
}

export default {
  init
};



// WEBPACK FOOTER //
// ./src/services/index.js